export default "__VITE_ASSET__BpFMDK91__"